import React from "react"
import styled from "@emotion/styled"
import tw from "twin.macro"

import { Subscribe } from "../Subscribe/Subscribe"
import { Icon } from "../Icon/Icon"
import { withNewsletterPopup } from "./withNewsletterPopup"
import { StyledContainer } from "../Styled/Container"
import { StyledH2, StyledP } from "../Styled/Text"

const Container = tw(StyledContainer)`fixed bottom-0 left-0 right-0 max-w-xl mx-auto p-1-6 md:pb-3-2 z-10`
const PopupOuter = tw.div`max-w-30 md:max-w-36 border border-dark bg-light rounded-1 p-1-6 py-3-2 md:p-3-2 md:pt-3 block relative`
const Description = tw(StyledP)`mt-1-2 mb-2`
const CloseButton = tw.button`w-2 h-2 bg-dark rounded-full flex items-center justify-center absolute top-0 left-0 -mt-1 -ml-1 text-light cursor-pointer`
const StyledIcon = styled(Icon)`
  ${tw`block`}
`

export const NewsletterPopup = withNewsletterPopup(({ title, message, dismiss, newsletter }) => {
  return (
    <Container width={`full`}>
      <PopupOuter>
        <CloseButton onClick={event => dismiss(event)}>
          <StyledIcon name={`crossRounded`} size={25} />
        </CloseButton>
        <StyledH2>{title}</StyledH2>
        <Description>{message}</Description>
        <Subscribe popup={true} newsletter={newsletter} dismiss={dismiss} />
      </PopupOuter>
    </Container>
  )
})
